import { isEmpty } from "@swiggy-private/core-ui";
import { ReviewedCart } from "@cart-client/interfaces/Cart";

import { RESTAURANT_CATEGORY_TYPE } from "@cart-client/interfaces/RestaurantCategory";

export function isBulkOrder(cartResponse: ReviewedCart | null): boolean {
    const categoryInfo = cartResponse?.data?.category_info_json;

    if (isEmpty(categoryInfo)) {
        return false;
    }

    try {
        const getValue = JSON.parse(categoryInfo) || {};
        if (isEmpty(getValue?.restaurantCategory?.[0])) {
            return false;
        } else {
            // taking 0th index value because category_info_json array will contain only 1 value at a time
            return getValue.restaurantCategory[0] === RESTAURANT_CATEGORY_TYPE.BULKORDER;
        }
    } catch (err) {
        return false;
    }
}

// getting the value of seconds from slot_end_time of first element, because the epoch time will give the same date for every slot and checkout requires the date only from portal
export function getDateFromApiResponse(reviewedCart: ReviewedCart | null): string {
    return String(reviewedCart?.data?.slot_details?.slots[0]?.slot_end_time?.seconds || "");
}
